var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { types, flow, } from "mobx-state-tree";
import _ from "lodash";
var SearchAndReplaceStore = types
    .model({
    searchQuery: types.optional(types.string, ""),
    replaceValue: types.optional(types.string, ""),
    isReplacing: types.optional(types.boolean, false),
    replaceCompleteProperty: types.optional(types.boolean, false),
    replaceIgnoreCase: types.optional(types.boolean, true),
})
    .named("SearchAndReplaceStore")
    .views(function (_self) { return ({
    getSearchResultValue: function (propertyName, dataItem) {
        return _.property(propertyName)(dataItem);
    },
}); })
    .actions(function (self) { return ({
    setSearchQuery: function (searchQuery) {
        self.searchQuery = searchQuery;
    },
    setReplaceValue: function (replaceValue) {
        self.replaceValue = replaceValue;
    },
    setReplaceCompleteProperty: function (replaceCompleteProperty) {
        self.replaceCompleteProperty = replaceCompleteProperty;
    },
    setReplaceIgnoreCase: function (replaceIgnoreCase) {
        self.replaceIgnoreCase = replaceIgnoreCase;
    },
    // flow(function* login(email: string, password: string): Generator<Promise<ApiResult<LoginResult>>, boolean | LoginError, ApiResult<LoginResult>>
    replace: flow(function replaceFlow(dataAccessStore, dataItem, propertyName, replaceCallback, customPatchHandler) {
        var currentValue, newValue, flags, patch, apiResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    self.isReplacing = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 4, 5]);
                    dataItem.beginEditing();
                    currentValue = self.getSearchResultValue(propertyName, dataItem);
                    newValue = self.replaceValue;
                    if (!self.replaceCompleteProperty) {
                        flags = "g";
                        if (self.replaceIgnoreCase) {
                            flags += "i";
                        }
                        newValue = currentValue.replace(new RegExp(_.escapeRegExp(self.searchQuery), flags), self.replaceValue);
                    }
                    replaceCallback(dataItem, newValue);
                    patch = dataItem.commitChanges();
                    if (!patch) return [3 /*break*/, 3];
                    return [4 /*yield*/, (customPatchHandler || dataAccessStore.patch)(dataItem.id, patch)];
                case 2:
                    apiResult = _a.sent();
                    if (!apiResult.ok) {
                    }
                    _a.label = 3;
                case 3:
                    console.log("try");
                    return [3 /*break*/, 5];
                case 4:
                    console.log("finally");
                    self.isReplacing = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }),
}); });
export default SearchAndReplaceStore;
//# sourceMappingURL=SearchAndReplaceStore.js.map